import api from '@services/api';

/**
 * <p>
 * API endpoints that cover all sync sharing and employee related CRUD calls
 */
export const syncSharingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    SyncSharing: builder.mutation<void, string>({
      query: (params: string) => ({
        url: encodeURI(`/report/person-expense/request?period=${params}`),
        method: 'POST',
      }),
      invalidatesTags: ['Projects'],
    }),
    syncEmployee: builder.mutation<void, string>({
      query: (params: string) => ({
        url: encodeURI(`/report/person-work-detail/requestDetails?period=${params}`),
        method: 'POST',
      }),
      invalidatesTags: ['Projects'],
    }),
  }),
});

export const { useSyncSharingMutation, useSyncEmployeeMutation } = syncSharingApi;
